import { LOGO_PATHS, LOGO_VIEWBOX, logoStrokeWidth } from './logoGeometry';

/**
 * The guanábana mark: a soft ovoid with one vertical spine and four ticks.
 * The same drawing at every size — only the stroke weight adapts, so the mark
 * on the sign-in page and the mark in the app shell are the same illustration.
 */
export function Logo({
  size = 32,
  tone = 'ink',
}: {
  size?: number;
  tone?: 'ink' | 'leaf' | 'cream';
}) {
  const stroke = tone === 'cream' ? '#F6F2E9' : tone === 'leaf' ? '#1E4034' : '#15201B';
  const strokeWidth = logoStrokeWidth(size);

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${LOGO_VIEWBOX} ${LOGO_VIEWBOX}`}
      fill="none"
      role="img"
      aria-label="Guabi"
      focusable="false"
    >
      <path d={LOGO_PATHS.ovoid} stroke={stroke} strokeWidth={strokeWidth} />
      <path d={LOGO_PATHS.spine} stroke={stroke} strokeWidth={strokeWidth} opacity={0.9} />
      <path d={LOGO_PATHS.ticks} stroke={stroke} strokeWidth={strokeWidth} opacity={0.75} />
    </svg>
  );
}

export function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span className={`font-display text-[22px] font-normal tracking-[0.09em] ${className}`}>
      Guabi
    </span>
  );
}
